module.exports = __webpack_public_path__ + "1d2cf229.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/work.jpg
// module id = 2753
// module chunks = 15